import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { IPalletDetails } from '../../../modules/API/Pallets/models/palletDetails'
import { Pallets } from '../../../modules/API/Pallets/pallets'
import { handleNotifications } from '../../utils/handleNotifications'
import CustomerSelector from './components/CustomerSelector'
import ProductCardList from './components/ProductCardList'
import useTransferTeuda from './hooks/useTransferTeuda'
import FancyButton from '../../../main/second/mainbar/knisotLines/Components/FancyButton'
import SearchInput from '../../inputs/inputSearch'
import ControlSearchPannelLayout from '../../Layouts/Wrappers/ControlSearchPannelLayout'
import CustomBlockLoader from '../../../main/second/mainbar/knisot/generic/CustomBlockLoader'
import { useTranslation } from 'react-i18next'

type Props = {
  teudaID: number
  subID: number
  closeFunc?: () => void
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const ErrorMessage = styled.p`
  color: tomato;
  font-size: 0.9rem;
  text-align: center;
  direction: rtl;
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 0.4em;
  flex-shrink: 0;
`

const SelectedBadge = styled.span`
  font-size: 0.78rem;
  color: #297f76;
  font-weight: 600;
  text-align: center;
  direction: rtl;
`

const TransferTeudaModal = ({ teudaID, subID, closeFunc }: Props) => {
  const [t] = useTranslation(['buttons'])
  const [items, setItems] = useState<IPalletDetails[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [fetchError, setFetchError] = useState<string | null>(null)
  const [searchQuery, setSearchQuery] = useState<string>('')

  useEffect(() => {
    const fetchItems = async () => {
      setIsLoading(true)
      setFetchError(null)
      try {
        const res: IPalletDetails[] = await Pallets.getPalletsDetailsByDelivery(teudaID, subID)
        setItems(res)
      } catch {
        setFetchError('שגיאה בטעינת פרטי התעודה')
        handleNotifications('שגיאה בטעינת פרטי התעודה', { type: 'error' })
      } finally {
        setIsLoading(false)
      }
    }

    fetchItems()
  }, [teudaID, subID])

  const {
    customerID,
    quantities,
    isSubmitting,
    selectedCount,
    handleCustomerChange,
    handleQtyChange,
    handleSubmit,
  } = useTransferTeuda({ teudaID, subID, items, closeFunc })

  if (isLoading) return <CustomBlockLoader />

  if (fetchError) return <ErrorMessage role="alert">{fetchError}</ErrorMessage>

  return (
    <Wrapper>
      <CustomerSelector customerID={customerID} onCustomerChange={handleCustomerChange} />
      <ControlSearchPannelLayout>
        <SearchInput input={searchQuery} setInput={setSearchQuery} />
      </ControlSearchPannelLayout>
      {selectedCount > 0 && (
        <SelectedBadge>נבחרו {selectedCount} פריטים להעברה</SelectedBadge>
      )}
      <ProductCardList
        items={items}
        quantities={quantities}
        searchQuery={searchQuery}
        onQtyChange={handleQtyChange}
      />
      <Footer>
        <FancyButton onClick={handleSubmit} isLoading={isSubmitting}>
          {t('buttons:save') }
        </FancyButton>
      </Footer>
    </Wrapper>
  )
}

export default TransferTeudaModal
